export default () => {
    // no suggestions
    return null;
};
//# sourceMappingURL=feedback.js.map